/**
 * Copyright schukai GmbH and contributors 2023. All Rights Reserved.
 * Node module: @schukai/monster
 * This file is licensed under the AGPLv3 License.
 * License text available at https://www.gnu.org/licenses/agpl-3.0.en.html
 */

export { extractKeys };

/**
 * Extracts the keys from the given object and returns a map with the keys and values.
 *
 * @private
 * @param {object} obj
 * @param {string} keyPrefix
 * @param {string} keySeparator
 * @param {string} valueSeparator
 * @returns {Map<any, any>}
 */
function extractKeys(
	obj,
	keyPrefix = "",
	keySeparator = "-",
	valueSeparator = ".",
) {
	const resultMap = new Map();

	function helper(currentObj, currentKeyPrefix, currentValuePrefix) {
		for (const key in currentObj) {
			if (
				currentObj[key] !== null &&
				typeof currentObj[key] === "object" &&
				!Array.isArray(currentObj[key])
			) {
				const newKeyPrefix = currentKeyPrefix
					? currentKeyPrefix + keySeparator + key.toLowerCase()
					: key.toLowerCase();
				const newValuePrefix = currentValuePrefix
					? currentValuePrefix + valueSeparator + key
					: key;
				helper(currentObj[key], newKeyPrefix, newValuePrefix);
			} else {
				const finalKey = currentKeyPrefix
					? currentKeyPrefix + keySeparator + key.toLowerCase()
					: key.toLowerCase();
				const finalValue = currentValuePrefix
					? currentValuePrefix + valueSeparator + key
					: key;
				resultMap.set(finalKey, finalValue);
			}
		}
	}

	helper(obj, keyPrefix, keyPrefix);
	return resultMap;
}
